import Api from '@silbo/core';
import { useMemo } from 'react';

const useMemoizedQuery = <T extends Parse.Object>(query: Parse.Query<T>, objectId?: string) => {
  const className = query.className;
  if (objectId) {
    // @ts-expect-error - where is not typed but when using Parse.Query.get(id), it will be set
    query.where = { objectId };
  }
  const queryJSON = JSON.stringify(query.toJSON());

  return useMemo(() => Api.Query.fromJSON(className, JSON.parse(queryJSON)) as Parse.Query<T>, [className, queryJSON]);
};

export default useMemoizedQuery;
